import * as React from "react";
import { cn } from "@/lib/utils";

export interface CardWrapperProps extends React.ComponentProps<"div"> {
  title?: string;
}

/**
 * CardWrapper is a frameless container for generative UI content.
 * It has no border or shadow since it's rendered inside MacOSWindowFrame.
 * Children are spaced using flex gap for proper composition.
 */
export function CardWrapper({
  title,
  className,
  children,
  ...props
}: CardWrapperProps): React.JSX.Element {
  return (
    <div
      data-slot="card-wrapper"
      className={cn(
        "flex flex-col gap-6 bg-card p-6 text-card-foreground",
        className,
      )}
      {...props}
    >
      {title && (
        <div className="text-lg leading-none font-semibold text-foreground">
          {title}
        </div>
      )}
      <div className="flex flex-col gap-6">{children}</div>
    </div>
  );
}
